'use client'
import Link from 'next/link'
import Logo from '../Logo'

const Footer = () => {
    return (
        <footer className="bg-neutral-950 bg-opacity-90 text-white py-12 w-full relative z-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-start mb-8">
                    <Link href="/">
                        <Logo style="abbreviated" className="mr-4" />
                    </Link>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* About Section */}
                    <div>
                        <Link href="/about"><h3 className="text-xs font-semibold mb-4 text-white">about.</h3></Link>
                        <ul className="space-y-2">
                            <li><Link href="/about/features" className="text-gray-400 hover:text-white transition-colors">Features</Link></li>
                            <li><Link href="/about/pricing" className="text-gray-400 hover:text-white transition-colors">Pricing</Link></li>
                            <li><Link href="/about/roadmap" className="text-gray-400 hover:text-white transition-colors">Roadmap</Link></li>
                            <li><Link href="/about/changelog" className="text-gray-400 hover:text-white transition-colors">Changelog</Link></li>
                            <li><Link href="/about/showcase" className="text-gray-400 hover:text-white transition-colors">Showcase Profiles</Link></li>
                            <li><Link href="/about/templates" className="text-gray-400 hover:text-white transition-colors">Templates</Link></li>
                        </ul>
                    </div>

                    {/* Help Section */}
                    <div>
                        <Link href="/support"><h3 className="text-xs font-semibold mb-4 text-white">help.</h3></Link>
                        <ul className="space-y-2">
                            <li><Link href="/support/faq" className="text-gray-400 hover:text-white transition-colors">FAQ</Link></li>
                            <li><Link href="/support/contact" className="text-gray-400 hover:text-white transition-colors">Contact Us</Link></li>
                            <li><Link href="/support/status" className="text-gray-400 hover:text-white transition-colors">Server Status</Link></li>
                            <li><Link href="/support/custom-css" className="text-gray-400 hover:text-white transition-colors">Custom Blocks and Styling</Link></li>
                        </ul>
                    </div>

                    {/* Legal Section */}
                    <div>
                        <Link href="/legal"><h3 className="text-xs font-semibold mb-4 text-white">legal.</h3></Link>
                        <ul className="space-y-2">
                            <li><Link href="/legal/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
                            <li><Link href="/legal/terms" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link></li>
                            <li><Link href="/legal/cookies" className="text-gray-400 hover:text-white transition-colors">Cookie Policy</Link></li>
                            <li><Link href="/legal/dpa" className="text-gray-400 hover:text-white transition-colors">Data Processing Agreement (Summit Users)</Link></li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-gray-800">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400">&copy; 2025 Autofoc.us LLC. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer